<div class="card card-nc esign_box ">
  <div class="navyCashHeading">
    Contact Us
  </div>
  <div class="row" style="font-size: 14px;">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            There was an error completing your enrollment.<br />
            <br />
            The Customer Service Center (CSC) operating hours are Monday through Friday
            from 6:00 AM to 8:00 PM CT (closed on all Federal Holidays). At 8:00 PM Monday through Friday, the phones
            will be routed to an after-hours script until opening the next business
            day. Please call the Cardholder phone number below. <br />
            <br />
            <b>Cardholder Phone Number</b><br />
            1-866-3NAVYCASH/1-866-362-8922<br />
            <br />
            <b>Additional Program Information</b><br />
            Visit
            <a href="http://www.fiscal.treasury.gov/stored-value-card"
              >www.fiscal.treasury.gov/stored-value-card</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
